module.exports = __webpack_public_path__ + "img/2024-02-13f_3.94e6ea70.jpg";